// extracted by mini-css-extract-plugin
module.exports = {"ShopList":"ShopList_ShopList__CNsnK"};